// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"bb633368","511":"051127b7"}[chunkId] + ".chunk.css";
};